/**
 * @fileoverview This file was generated by the Angular template compiler. Do not edit.
 *
 * @suppress {suspiciousCode,uselessCode,missingProperties,missingOverride,checkTypes}
 * tslint:disable
 */ 
var styles = [".modal-body[_ngcontent-%COMP%]{padding:0 0 1.6rem 0}button[_ngcontent-%COMP%]:focus{outline:0}.modal-header[_ngcontent-%COMP%]{background-color:#0080ff;display:-webkit-box;display:flex;-webkit-box-align:center;align-items:center;-webkit-box-pack:center;justify-content:center}.modal-title[_ngcontent-%COMP%], button[_ngcontent-%COMP%]{color:#fff}"];
export { styles as styles };
//# sourceMappingURL=teacher-feedback-modal.component.scss.shim.ngstyle.js.map


//////////////////
// WEBPACK FOOTER
// ./ts/app/teacher-feedback/teacher-feedback-modal/teacher-feedback-modal.component.scss.shim.ngstyle.js
// module id = 1371
// module chunks = 27 28 29